import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import {Marker, Popup, useMap} from 'react-leaflet';
import { Context } from '../store/reducer';
import { Line } from "react-chartjs-2";

import m_rainfall_0 from '../assets/img/marker/weather/m_fuukou_0.png';
import m_rainfall_1 from '../assets/img/marker/weather/m_fuukou_1.png';
import m_rainfall_2 from '../assets/img/marker/weather/m_fuukou_2.png';
import m_rainfall_3 from '../assets/img/marker/weather/m_fuukou_3.png';
import m_rainfall_4 from '../assets/img/marker/weather/m_fuukou_4.png';
import m_rainfall_5 from '../assets/img/marker/weather/m_fuukou_5.png';
import m_rainfall_6 from '../assets/img/marker/weather/m_fuukou_6.png';
import m_rainfall_7 from '../assets/img/marker/weather/m_fuukou_7.png';



/**
 * 39: 河川管理情報システム 風向風速日集計
 * @param options
 * @returns {null}
 * @constructor
 */
const Component = ({options}) => {

    const editedValue = (value) => {
        
        switch (value) {
            case "--":
                return "-- 未収集";
            case "MM":
                return "MM　保守中";
            case "CC":
                return "CC　休止局";
            case "**":
                return "** 欠測";
            case "":
                return "(空白)　無効";
            default:
                return value;
        }
    };

    /**
     * 風向と風速の表の表示
     * @param item
     * @returns {*[]}
     */
    const handleWindData = (item) => {
        
        let labels      = [];

        let mainTable = []
        
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>データ種別</dt><dd>{item["station_type_label"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>事業所名</dt><dd>{item["office_name"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>データ所管</dt><dd>{item["department"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>水系名</dt><dd>{item["water_system_name"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>河川名</dt><dd>{item["river_name"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>観測所番号</dt><dd>{item["observatory_id"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>観測所名</dt><dd>{item["name"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{item["lat"]}</dd></dl>)
        mainTable.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{item["lng"]}</dd></dl>)

        let ret = []
        
        ret.push(<tr>
            <th style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>観測時刻</th>
            <th style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>風向(10分平均)</th>
            <th style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>風速(10分平均)<br />[m/s]</th>
            <th style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>風向(最大瞬間)</th>
            <th style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>風速(最大瞬間)<br />[m/s]</th>
        </tr>);

        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];

            labels.push(rainData.datetime);

            ret.push(<tr>
                <td style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>{ rainData.datetime }</td>
                <td style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>{ editedValue(rainData.value1) }</td>
                <td style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>{ editedValue(rainData.value2) }</td>
                <td style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>{ editedValue(rainData.value3) }</td>
                <td style={{border:1, borderStyle:"solid", borderWidth:"1px"}}>{ editedValue(rainData.value4) }</td>
            </tr>);
        });
        
        return (
          <>
              { mainTable }
              <br />
              <table className='c-tbl c-tbl-1'>
                  {ret}
              </table>
          </>
        )
    }


    const map = useMap()
    const { state } = useContext(Context);

    return Object.keys(state["vis_39"].data).map((key, index) => {
        
        const item = state["vis_39"].data[key];
        
        let labels = [];
        
        let wind_value1_list = [];
        // let wind_value2_list = [];

        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];
            
            labels.push(rainData.datetime);
            
            wind_value1_list.push(rainData.value2);
        })

        // 現在のスライダーの値(風向(10分平均))
        const currentTenMinutesValue = wind_value1_list[state.timeIdx] ? wind_value1_list[state.timeIdx] : 0;

        // グレー
        let icon = m_rainfall_1

        if (currentTenMinutesValue === "**"
          || currentTenMinutesValue === "--"
          || currentTenMinutesValue === "") {
            // 欠測: グレー
            icon = m_rainfall_1

        } else if (currentTenMinutesValue === "MM"
          || currentTenMinutesValue === "CC") {
            // 閉局・メンテナンス: バツ付きグレー
            icon = m_rainfall_0

        } else if (currentTenMinutesValue < 5) {
            // 5m/s 未満: 白
            icon = m_rainfall_2
        } else if (currentTenMinutesValue < 10) {
            // 10m/s 未満: 水
            icon = m_rainfall_3
        } else if (currentTenMinutesValue < 15) {
            // 15m/s 未満: 青
            icon = m_rainfall_4
        } else if (currentTenMinutesValue < 20) {
            // 20m/s 未満: 黄色
            icon = m_rainfall_5
        } else if (currentTenMinutesValue < 25) {
            // 25m/s 未満: オレンジ
            icon = m_rainfall_6
        } else if (currentTenMinutesValue >= 25) {
            // 25m/s 以上: 赤
            icon = m_rainfall_7
        }
        
        // if (item["name"] === "東広島") {
        //     console.log("日時", labels[state.timeIdx])
        //     console.log("10分平均", currentTenMinutesValue)
        //     console.log("item[\"name\"]", item["name"])
        //     console.log("icon", icon)
        // }
        
        const iconUrl = new L.Icon({
            iconUrl: icon,
            iconRetinaUrl: icon,
            iconSize: [35, 35],
            iconAnchor: [17, 23],
            popupAnchor: [0, -50]
        });
        

        return (
          <>
              <Marker
                position={[item.lat, item.lng]}
                icon={iconUrl}
              >
                  <Popup autoPan={false} minHeight={300} maxHeight={400} minWidth={600} closeOnClick>
                      {
                          handleWindData(item)
                      }
                  </Popup>
              </Marker>

          </>
        );
    })
}

export default Component
